import React, { useState } from "react";
import { Document, Page, pdfjs } from "react-pdf";
import {
  Button,
  Modal,
  Box,
  IconButton,
  Typography,
  Stack,
  useTheme,
  useMediaQuery,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import NavigateBeforeIcon from "@mui/icons-material/NavigateBefore";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";

import "react-pdf/dist/esm/Page/AnnotationLayer.css";
import "react-pdf/dist/esm/Page/TextLayer.css";

// Worker de PDF
pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.js`;

const VisorDePDF = ({ archivo }) => {
  const [abierto, setAbierto] = useState(false);
  const [paginas, setPaginas] = useState(null);
  const [viendo, setViendo] = useState(1);
  const theme = useTheme();

  const esXs = useMediaQuery(theme.breakpoints.down("sm"));
  const esSm = useMediaQuery(theme.breakpoints.between("sm", "md"));
  const esMd = useMediaQuery(theme.breakpoints.between("md", "lg"));

  const getAnchoPDF = () => {
    let base = archivo === "CodeCademy" ? 900 : 750;
    if (esXs) return Math.min(window.innerWidth * 0.85, 320);
    if (esSm) return 400;
    if (esMd) return base * 0.8;
    return base;
  };

  const pdfUrl =
    process.env.PUBLIC_URL +
    {
      SENA: "/Diploma_SENA.pdf",
      CodeCademy: "/CodeCademy.pdf",
    }[archivo];

  const onCargaDocumento = ({ numPages }) => setPaginas(numPages);

  return (
    <>
      <Button
        variant="outlined"
        color="theme.palette.primary.main"
        onClick={() => setAbierto(true)}
        sx={{
          color: theme.palette.secondary.main,
          fontWeight: 600,
          textTransform: "none",
        }}
      >
        Ver certificado
      </Button>

      <Modal
        data-aos="fade-right"
        open={abierto}
        onClose={() => setAbierto(false)}
      >
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: "100%",
            maxWidth: getAnchoPDF() + 40,
            bgcolor: theme.palette.background.paper,
            borderRadius: 2,
            boxShadow: 24,
            p: { xs: 2, sm: 3 },
            outline: "none",
            overflowY: "auto",
            maxHeight: "90vh",
          }}
        >
          {/* Botón cerrar */}
          <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
            <IconButton onClick={() => setAbierto(false)} color="error">
              <CloseIcon />
            </IconButton>
          </Box>

          {/* Contenedor PDF */}
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              mb: 2,
              minHeight: "200px", // previene colapso visual en carga lenta
            }}
          >
            <Document
              file={pdfUrl}
              onLoadSuccess={onCargaDocumento}
              loading="Cargando PDF..."
              error="Error al cargar el PDF"
            >
              {paginas && (
                <Page
                  pageNumber={viendo}
                  width={getAnchoPDF()}
                  renderMode="canvas" // Mejora compatibilidad en móviles
                  loading="Cargando página..."
                />
              )}
            </Document>
          </Box>

          {/* Navegación de páginas */}
          {paginas && (
            <Stack
              direction="row"
              spacing={2}
              alignItems="center"
              justifyContent="center"
              mt={2}
              flexWrap="wrap"
            >
              <Button
                variant="contained"
                startIcon={<NavigateBeforeIcon />}
                onClick={() => setViendo(viendo - 1)}
                disabled={viendo <= 1}
              >
                Anterior
              </Button>
              <Typography>
                Página {viendo} de {paginas}
              </Typography>
              <Button
                variant="contained"
                endIcon={<NavigateNextIcon />}
                onClick={() => setViendo(viendo + 1)}
                disabled={viendo >= paginas}
              >
                Siguiente
              </Button>
            </Stack>
          )}
        </Box>
      </Modal>
    </>
  );
};

export default VisorDePDF;
